import styled from "@emotion/styled";
var Anchor = /*#__PURE__*/ styled("a", {
    target: "e1gq1ls80"
})("display:flex;flex-wrap:nowrap;align-items:center;color:inherit;text-decoration:inherit;");
export { Anchor };
